export class GcpAccountConfigInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "serviceAccount",
            "baseName": "serviceAccount",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpAccountConfigInput.attributeTypeMap;
    }
    constructor() {
    }
}
